<template>
    <div class="row g-6">
        <div class="col-12">
            <div class="row">
                <h6 class="settings-title">Дополнительные настройки:</h6>
                <div class="row">
                    <div class="col-md-3 d-flex align-items-center" style="min-height: 48px;">
                        <label class="form-label mb-0" for="strategyActive">Стратегия активна</label>
                    </div>
                    <div class="col-md-9 d-flex align-items-center" style="min-height: 48px;">
                        <div class="form-check form-switch">
                            <input class="form-check-input" type="checkbox" v-model="localStrategy.is_active"
                                id="strategyActive">
                        </div>
                    </div>
                    <div class="col-md-3 d-flex align-items-center" style="min-height: 48px;">
                        <label class="form-label mb-0" for="strategyOrderType">Тип заказа для расчетов комиссии</label>
                    </div>
                    <div class="col-md-9 d-flex align-items-center" style="min-height: 48px;">
                        <Select v-model="localStrategy.settings.order_type" :options="OrderTypes" optionLabel="name"
                            optionValue="value" id="strategyOrderType" placeholder="Тип заказа" />
                    </div>
                    <div class="col-md-3 d-flex align-items-center" style="min-height: 48px;">
                        <label class="form-label mb-0" for="strategyCheckRRC">Контролировать РРЦ</label>
                    </div>
                    <div class="col-md-9 d-flex align-items-center" style="min-height: 48px;">
                        <div class="form-check form-switch">
                            <input class="form-check-input" type="checkbox" v-model="localStrategy.settings.check_rrp"
                                id="strategyCheckRRC">
                        </div>
                    </div>
                    <template v-if="localStrategy.settings.check_rrp && !isYandex">
                        <div class="col-md-3 d-flex align-items-center" style="min-height: 48px;">
                            <label class="form-label mb-0" for="strategyRrpPriceType">
                                На какую цену ориентировать РРЦ
                                <i
                                    class="ti ti-info-circle ti-sm ms-1"
                                    v-tooltip.bottom="RrpPriceTypeHint"
                                ></i>
                            </label>
                        </div>
                        <div class="col-md-9 d-flex align-items-center" style="min-height: 48px;">
                            <Select
                                v-model="localStrategy.settings.rrp_price_type"
                                :options="RrpPriceTypes"
                                optionLabel="label"
                                optionValue="value"
                                id="strategyRrpPriceType"
                                placeholder="Тип цены РРЦ"
                            >
                                <template #value="slotProps">
                                    <div class="d-flex align-items-center" v-if="slotProps.value != null && slotProps.value !== ''">
                                        <span>{{ rrpPriceTypeLabel(slotProps.value) }}</span>
                                        <span v-if="isRrpPriceTypeBeta(slotProps.value)" class="rrp-beta ms-2">Beta</span>
                                    </div>
                                    <span v-else>{{ slotProps.placeholder }}</span>
                                </template>
                                <template #option="slotProps">
                                    <div class="d-flex align-items-center">
                                        <span>{{ slotProps.option.label }}</span>
                                        <span v-if="slotProps.option.beta" class="rrp-beta ms-2">Beta</span>
                                    </div>
                                </template>
                            </Select>
                        </div>
                        <div v-if="needsShowcaseTracking" class="col-md-9 offset-md-3">
                            <div class="alert alert-secondary py-2 mb-0 mt-1" role="alert">
                                {{ RrpPriceTypeTrackingHint }}
                                <router-link :to="SHOWCASE_PRICES_PATH" target="_blank" rel="noopener noreferrer">Цены на витрине</router-link>
                            </div>
                        </div>
                    </template>
                    <div class="col-md-3 d-flex align-items-center" style="min-height: 48px;">
                        <label class="form-label mb-0" for="strategySkipPriceDecrease">
                            Пропускать обновление при снижении цены
                            <i
                                class="ti ti-info-circle ti-sm ms-1"
                                v-tooltip.bottom="'Если рассчитанная цена ниже текущей, изменение не будет передано'"
                            ></i>
                        </label>
                    </div>
                    <div class="col-md-9 d-flex align-items-center" style="min-height: 48px;">
                        <div class="form-check form-switch">
                            <input class="form-check-input" type="checkbox" v-model="localStrategy.settings.skip_price_decrease"
                                id="strategySkipPriceDecrease">
                        </div>
                    </div>
                    <div class="col-md-3 d-flex align-items-center" style="min-height: 48px;">
                        <label class="form-label mb-0" for="strategyScheduleActive">Запуск по расписанию</label>
                    </div>
                    <div class="col-md-9 d-flex align-items-center" style="min-height: 48px;">
                        <div class="form-check form-switch">
                            <input class="form-check-input" type="checkbox" v-model="isScheduled"
                                id="strategyScheduleActive">
                        </div>
                    </div>
                    <template v-if="isScheduled">
                        <div class="col-md-3 d-flex align-items-center" style="min-height: 48px;">
                            <label class="form-label mb-0" for="strategyScheduleHours">Часы запуска</label>
                        </div>
                        <div class="col-md-9 d-flex align-items-center" style="min-height: 48px;">
                            <MultiSelect v-model="scheduleHours"
                                :options="hoursOptions"
                                :maxSelectedLabels="8"
                                :selectionLimit="8"
                                id="strategyScheduleHours"
                                placeholder="Выберите часы (макс. 8)"
                                optionLabel="label"
                                optionValue="value"
                            />
                        </div>
                    </template>
                    <template v-if="isOzon">
                        <div class="col-md-3 d-flex align-items-center" style="min-height: 48px;">
                            <label class="form-label mb-0" for="ozonRemoveFromActions">Если товар в акции по более низкой цене — удалять</label>
                        </div>
                        <div class="col-md-9 d-flex align-items-center" style="min-height: 48px;">
                            <div class="form-check form-switch">
                                <input
                                    class="form-check-input"
                                    type="checkbox"
                                    v-model="localStrategy.settings.additional_params.ozon_remove_from_actions"
                                    id="ozonRemoveFromActions"
                                >
                            </div>
                        </div> 
                        <div class="col-md-3 d-flex align-items-center" style="min-height: 48px;">
                            <label class="form-label mb-0" for="ozonMinPriceAction">Действие при наличии минимальной цены</label>
                        </div>
                        <div class="col-md-9 d-flex align-items-center" style="min-height: 48px;">
                            <Select v-model="localStrategy.settings.additional_params.ozon_min_price_action" :options="ozonMinPriceActions" optionLabel="label" optionValue="value" id="ozonMinPriceAction" placeholder="Действие" />
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Strategy from "@/models/strategy";
import { OrderTypes } from "@/data/orders";
import { RrpPriceTypes, RrpPriceTypeHint, RrpPriceTypeTrackingHint, SHOWCASE_PRICES_PATH, formatRrpPriceType, isRrpPriceTypeBeta } from "@/data/rrp";
import { Select } from "primevue";
import { MultiSelect } from "primevue";
import Tooltip from 'primevue/tooltip';

export default {
    name: 'StrategyAdditionalSettings',
    components: { Select, MultiSelect },
    directives: {
        tooltip: Tooltip
    },
    props: {
        strategy: {
            type: Object,
            required: true
        },
        stores: {
            type: Array,
            required: true,
            default: () => []
        }
    },
    data() {
        return {
            localStrategy: new Strategy(),
            OrderTypes,
            RrpPriceTypes,
            RrpPriceTypeHint,
            RrpPriceTypeTrackingHint,
            SHOWCASE_PRICES_PATH,
            isScheduled: false,
            scheduleHours: [],
            hoursOptions: Array.from({ length: 24 }, (_, i) => ({ label: `${i}:00`, value: i })),
            ozonMinPriceActions: [{
                value: 'raise_error',
                label: 'Выдать ошибку'
            }, {
                value: 'change_min',
                label: 'Изменить минимальную цену'
            }],
        }
    },
    watch: {
        strategy: {
            handler(newVal) {
                if (JSON.stringify(this.localStrategy) !== JSON.stringify(newVal)) {
                    this.localStrategy = new Strategy(newVal)

                    if (newVal.schedule && newVal.schedule.rule === 'hours') {
                        console.log('newVal.schedule', newVal.schedule)
                        this.isScheduled = true;
                        this.scheduleHours = Array.isArray(newVal.schedule.value)
                            ? newVal.schedule.value.map(Number)
                            : [];
                        console.log('this.scheduleHours', this.scheduleHours)
                        console.log('options', this.hoursOptions)
                    } else {
                        this.isScheduled = false;
                        this.scheduleHours = [];
                    }
                }
            },
            deep: true,
            immediate: true
        },
        localStrategy: {
            handler(newVal) {
                if (JSON.stringify(this.strategy) !== JSON.stringify(newVal)) {
                    this.$emit('update:strategy', newVal)
                }
            },
            deep: true
        },
        isScheduled(val) {
            if (!val) {
                this.localStrategy.schedule = null;
                this.scheduleHours = [];
            } else {
                this.localStrategy.schedule = {
                    rule: 'hours',
                    value: this.scheduleHours
                };
            }
        },
        scheduleHours(val) {
            if (this.isScheduled) {
                const hours = Array.isArray(val) ? val.slice(0, 8) : [];
                this.localStrategy.schedule = {
                    rule: 'hours',
                    value: hours
                };
            }
        }
    },
    computed: {
        selectedStore() {
            return this.stores.find(s => s.id === this.localStrategy.store_id);
        },
        isOzon() {
            return this.selectedStore && this.selectedStore.marketplace === 'ozon';
        },
        isYandex() {
            return this.selectedStore && this.selectedStore.marketplace === 'yandex';
        },
        needsShowcaseTracking() {
            const type = this.localStrategy.settings.rrp_price_type;
            return type === 'default' || type === 'card';
        }
    },
    methods: {
        rrpPriceTypeLabel: formatRrpPriceType,
        isRrpPriceTypeBeta,
    },
    mounted() {
        if (typeof this.localStrategy.settings.skip_price_decrease === 'undefined') {
            this.localStrategy.settings.skip_price_decrease = false;
        }
        if (!this.localStrategy.settings.rrp_price_type) {
            this.localStrategy.settings.rrp_price_type = 'standard';
        }
        if (!this.localStrategy.settings.additional_params) {
            this.localStrategy.settings.additional_params = {};
        }
        if (typeof this.localStrategy.settings.additional_params.ozon_remove_from_actions === 'undefined') {
            this.localStrategy.settings.additional_params.ozon_remove_from_actions = false;
        }
        if (typeof this.localStrategy.settings.additional_params.ozon_min_price_action === 'undefined') {
            this.localStrategy.settings.additional_params.ozon_min_price_action = 'raise_error';
        }
    }
}
</script>

<style>
.rrp-beta {
  display: inline-flex;
  align-items: center;
  padding: 1px 7px;
  border-radius: 999px;
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  line-height: 1.4;
  background: rgba(115, 103, 240, 0.12);
  color: #7367f0;
}
</style>
